"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _store = _interopRequireDefault(require("./store"));

var _Betbar = _interopRequireDefault(require("./Betbar"));

var _defaultTranslations = _interopRequireDefault(require("./defaultTranslations"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      betbarParent = _ref.betbarParent,
      setBetbarParent = _ref.setBetbarParent,
      app = _ref.app,
      setApp = _ref.setApp,
      isLoggedIn = _ref.isLoggedIn,
      isDpg = _ref.isDpg,
      isLeaderboard = _ref.isLeaderboard,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages,
      setContest = _ref.setContest,
      getLeaderboard = _ref.getLeaderboard,
      history = _ref.history,
      disableDropdown = _ref.disableDropdown,
      showNavigationArrows = _ref.showNavigationArrows,
      hideHelp = _ref.hideHelp,
      hideLeaderboardRow = _ref.hideLeaderboardRow,
      showOnlyFixture = _ref.showOnlyFixture,
      showLoginButton = _ref.showLoginButton,
      onClearButtonClicked = _ref.onClearButtonClicked,
      onHelpButtonClicked = _ref.onHelpButtonClicked,
      onLoginButtonClicked = _ref.onLoginButtonClicked,
      onLogoutButtonClicked = _ref.onLogoutButtonClicked,
      onSignupButtonClicked = _ref.onSignupButtonClicked,
      progressTotal = _ref.progressTotal,
      progressCurrent = _ref.progressCurrent,
      brandingImageUrl = _ref.brandingImageUrl;

  if (!translations) {
    translations = _defaultTranslations.default;
  }

  console.log("hideHelp", hideHelp);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRedux.Provider, {
    store: _store.default,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Betbar.default, {
      showOnlyFixture: showOnlyFixture,
      showLoginButton: showLoginButton,
      hideLeaderboardRow: hideLeaderboardRow,
      onLoginButtonClicked: onLoginButtonClicked,
      onLogoutButtonClicked: onLogoutButtonClicked,
      onSignupButtonClicked: onSignupButtonClicked,
      onClearButtonClicked: onClearButtonClicked,
      onHelpButtonClicked: onHelpButtonClicked,
      translations: translations,
      betbarParent: betbarParent,
      setBetbarParent: setBetbarParent,
      app: app,
      setApp: setApp,
      isDpg: isDpg,
      isLoggedIn: isLoggedIn,
      isUsingAlternativeImages: isUsingAlternativeImages,
      hideHelp: hideHelp,
      disableDropdown: disableDropdown,
      showNavigationArrows: showNavigationArrows,
      isLeaderboard: isLeaderboard,
      history: history,
      setContest: setContest,
      getLeaderboard: getLeaderboard,
      progressTotal: progressTotal,
      progressCurrent: progressCurrent,
      brandingImageUrl: brandingImageUrl
    })
  });
};

var _default = Wrapper;
exports.default = _default;